import React, { useEffect } from 'react';

const TrustpilotInitializer = () => {
  useEffect(() => {
    // Function to initialize Trustpilot widgets
    const initializeTrustpilot = () => {
      // Check if Trustpilot is available
      if (window.Trustpilot) {
        console.log('Trustpilot loaded, initializing widgets...');
        // Find all Trustpilot widgets and initialize them
        const widgets = document.querySelectorAll('.trustpilot-widget');
        widgets.forEach(widget => {
          if (window.Trustpilot.loadFromElement) {
            window.Trustpilot.loadFromElement(widget);
          }
        });
      } else {
        console.log('Trustpilot not yet loaded, retrying...');
        // Retry after delay if Trustpilot is not loaded
        setTimeout(initializeTrustpilot, 1000);
      }
    };

    // Wait for DOM to be ready
    const timer = setTimeout(() => {
      initializeTrustpilot();
    }, 100);

    // Also try immediately in case DOM is already ready
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initializeTrustpilot();
    }

    return () => {
      clearTimeout(timer);
    };
  }, []);

  return null;
};

export default TrustpilotInitializer;
